import { observable } from "micro-observables";
export const complementaryTooltipVisible = observable(false);
export const complementaryQuickstartOrigin = observable(false);
export const showComplementaryTooltip = (): void => {
	complementaryTooltipVisible.set(true);
	complementaryQuickstartOrigin.set(true);
};
export const hideComplementaryTooltip = (): void => complementaryTooltipVisible.set(false);
export const clearComplementaryQuickstartOrigin = (): void => complementaryQuickstartOrigin.set(false);
export const complementaryGuide3ForceVisible = observable(false);
export const showComplementaryGuide3 = (): void => complementaryGuide3ForceVisible.set(true);
export const hideComplementaryGuide3 = (): void => complementaryGuide3ForceVisible.set(false);
export const resetComplementaryGuide3 = (): void => {
	complementaryGuide3ForceVisible.set(false);
};
